import { render } from "./VideoPlayer.vue?vue&type=template&id=60285e6a&scoped=true&ts=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=60285e6a&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60285e6a"]])

export default __exports__